export default __webpack_public_path__ + "static/media/football-manager@2x.4e370154.webp";